import { Injectable } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  public css = {
    container: 'backdrop',
    popup: '',
    header: '',
    title: '',
    icon: '',
    image: '',
    content: '',
    htmlContainer: 'text-left',
    input: '',
    inputLabel: '',
    validationMessage: '',
    actions: '',
    closeButton: 'btn mx-2',
    confirmButton: 'btn mx-2 btn-primary',
    cancelButton: 'btn mx-2',
    denyButton: '',
    loader: '',
    footer: ''
  };

  public fireError(title: string, text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title,
      text,
      customClass: this.css,
      reverseButtons: true,
      buttonsStyling: false
    });
  }

  public fireConfirm(title: string, text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title,
      text,
      customClass: this.css,
      showCancelButton: true,
      reverseButtons: true,
      buttonsStyling: false
    });
  }

  public fireWarning(title: string, text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title,
      text,
      customClass: this.css,
      showCancelButton: true,
      reverseButtons: true,
      buttonsStyling: false
    });
  }
}
